export default __webpack_public_path__ + "b2734f9860ae5b0c3ac6fbf97009b90d.svg";